import ResendSharingInvitation from "./resend-sharing-invitation";

export default ResendSharingInvitation;
